<template>

<div class="table-view schades" id="pagingtop">
	<div class="card">
		<div class="card-header" v-if="totaalSchades.length == 0 || pageDataFailed">
			<h3><span>Mijn schades</span></h3>
		</div>

		<!-- LOADER -->
        	<loader-component v-if="!pageDataLoaded && !pageDataFailed"></loader-component>
        <!-- /LOADER -->

		<!-- show text instead of table when customer has no reported damages -->
		<div v-if="totaalSchades.length == 0 && pageDataLoaded" class="card-block">
			<p>U heeft nog geen schades gemeld.</p>
		</div>
		<!-- end show text 0 damages -->

		<!-- show error text when call is unsuccessful -->
		<div id="error-mijnschades" class="card-block" v-if="pageDataFailed">
			<p>Wij hebben geen schades kunnen vinden.</p>
		</div>
		<!-- end show error text when call is unsuccessful -->

		<!-- hide table till data is available -->
		<table class="table" v-if="pageDataLoaded">
		  <thead>
		    <tr>
		      <th class="date">Datum</th>
		      <th class="damage-num">Schadenr.</th>
		      <th class="insurance">Verzekering</th>
		      <th class="damage-type">Soort schade</th>
		      <th class="status">Status</th>
		    </tr>
		  </thead>
		  <tbody v-for="schade in chunkedArray[currentPage]" :key="schade.schadenummer">
		    <tr class="main" :class="{open: schade.isOpen}" @click="schade.isOpen = !schade.isOpen">
		      <td class="date">{{ schade.schadedatum }}</td>
		      <td class="damage-num">{{ schade.schadenummer }}</td>
		      <td class="insurance">
					{{ schade.produktNaam }}
					<span v-if="schade.kenteken"> | {{ schade.kenteken }}</span>
					<span v-if="schade.produktTypeNaam == 'woonhuis' || schade.produktTypeNaam == 'inboedel'"> | {{ schade.straat }}</span>
		      <td class="damage-type">{{ schade.schadesoort }}</td>
		      <td class="status">
					<span v-if!="null" :class="[{'tag':schade.schadestatus == 'afgehandeld'},{'tag tag-danger':schade.schadestatus == 'wacht op uw reactie'}, {'tag tag-success':schade.schadestatus == 'in behandeling'}, {'tag tag-success':schade.schadestatus == 'beoordeling'}, {'tag tag-success':schade.schadestatus == 'ontvangen'}]">
						{{ schade.schadestatus }}
					</span>
			  </td>
		    </tr>
		    <tr class="details" :class="{open: schade.isOpen}">
					<td colspan="3">
						<div>
							<span class="icon clean" v-on:click='schade.isOpen = !schade.isOpen'>0</span>
							<p class="tag" :class="[{'tag-danger':schade.schadestatus == 'wacht op uw reactie'}, {'tag-success':schade.schadestatus == 'in behandeling'}, {'tag-success':schade.schadestatus == 'beoordeling'}, {'tag-success':schade.schadestatus == 'ontvangen'}]">{{ schade.schadestatus }}</p>
							<div v-show="schade.isOpen" class="row">
								<div class="col-mo-6 col-xs-12">
									<label>Soort schade</label>
									<p>{{ schade.schadesoort }}</p>
								</div>
								<div class="col-mo-6 col-xs-12">
									<label v-if="schade.kenteken">Kenteken</label>
									<p>{{ schade.kenteken }}</p>
									<label v-if="schade.produktTypeNaam == 'woonhuis' || schade.produktTypeNaam == 'inboedel'">Adres</label>
									<p>{{ schade.straat }}</p>
								</div>
							</div>
						</div>
					</td>
				</tr>
		  </tbody>
		</table>
		
		<nav class="paging" v-if="totalPages > 1">
		  <ul class="pagination">
		    <li class="page-item">
		    	<button class="previous btn btn-secondary" @click="currentPage -= 1" v-if="currentPage > 0" data-href="#pagingtop" type="button">Vorige</button>
		    </li>
		    <li class="page-item" v-for="pageNumber in totalPages" :key="pageNumber">
		    	<button class="btn btn-secondary" @click="currentPage = pageNumber - 1" :class="{active: pageNumber === currentPage + 1}" data-href="#pagingtop" type="button">{{ pageNumber }}</button>
		    </li>
		    <li class="page-item">
		    	<button class="next btn btn-secondary" @click="currentPage += 1" v-if="currentPage < totalPages - 1" data-href="#pagingtop" type="button">Volgende</button>
		    </li>
		  </ul>
		</nav>
		<p class="aantalfacturen" v-if="pageDataLoaded">
			<span v-if="totaalSchades == 1"><strong>1</strong> schade gevonden</span>
			<span v-else><strong>{{ totaalSchades }}</strong> schades gevonden</span>
		</p>
	</div>
</div>
</template>

<script>

export default {
  name: 'mijnschades-component',
  props: {
	  ctx: String
  },
  data: function () {
    return {    	
		isOpen: false,
    	currentPage: 0,
        itemsPerPage: "",
        totalPages: "",
        chunkedArray: [],
    	pageToShow: "",
    	totaalSchades: "",
		pageDataLoaded: false,
        pageDataFailed: false
    }
	},
  mounted: function () {		
	var self = this;
	$.ajax({
		url: this.ctx + "/services/mijnschades/getall",
		type: 'GET',
		success: function(mijnschades) {
			mijnschades.forEach(function (d) {
      		   return self.$set(d, 'isOpen', false);
      		});

			var currentPage = 0;
			self.pageDataLoaded = true;
			
			let i, j, chunkedArray = [], chunk = 5;
		    for (i=0, j=0; i < mijnschades.length; i += chunk, j++) {
		        chunkedArray[j] = mijnschades.slice(i,i+chunk);
		    }
		    self.totalPages = chunkedArray.length;
		    self.itemsPerPage = chunk;
		    self.pageToShow = chunkedArray[currentPage];
		    self.chunkedArray = chunkedArray;
		    self.totaalSchades = mijnschades.length;
		      
			return chunkedArray;			 
		},
		error: function() {
            self.pageDataFailed = true;
		}
	});	
  }
}

</script>




// WEBPACK FOOTER //
// mijnschades.vue?e02816e6